import { Input } from '@antimatterhq/ui/components/input';
import { Icon } from '@antimatterhq/ui/components/icon';
import { useAtom } from 'jotai';
import { dataSourceFilterAtom } from '@/atoms/dataSources/dataSourcesAtoms';

export const DataSourceFilter = () => {
  const [value, setValue] = useAtom(dataSourceFilterAtom);

  return (
    <div className="relative max-w-[262px]">
      <Input
        value={value ?? ''}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Search sources"
        className="pr-8"
      />
      {value && (
        <button
          type="button"
          onClick={() => setValue('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-grey-400 hover:text-grey-700"
        >
          <Icon icon="lucide:x" className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};
